interface useButtonActionsOptions {
  selector?: string;
}
/**
 * Get button actions by data-action attribute and bind functions to them via generateButtonActions method
 * @param options
 * @returns
 */
export function useButtonActions(options?: useButtonActionsOptions) {
  const { selector = '[data-action]' } = options || {};
  let actions: Record<string, () => void> = {};

  function bindActionFunction(e: any, actionName: string) {
    e.preventDefault();
    actions?.[actionName]?.();
  }

  function handleListeners(listenerType: 'add' | 'remove') {
    const elements = document.querySelectorAll(selector);
    for (const elementItem of elements) {
      const actionName = elementItem.getAttribute('data-action');
      if (actionName && actions[actionName]) {
        if (listenerType === 'add') {
          elementItem.addEventListener('click', (e) => bindActionFunction(e, actionName));
        } else {
          elementItem.removeEventListener('click', (e) => bindActionFunction(e, actionName));
        }
        continue;
      }
    }
  }

  function generateButtonActions(actionsParam: Record<string, () => void>) {
    actions = actionsParam;
    handleListeners('add');
  }

  onBeforeUnmount(() => {
    handleListeners('remove');
  });

  return { generateButtonActions };
}
